const bannerRouter = [
    {
        path: "list-banner",
        name: "list",
        component: () => import("@/views/admin/banner"),
        default: true,
        meta: {
            model: "banner",
            // requiresAuth: true,
        },
    },
    {
        path: "list-banner/add",
        name: "add",
        component: () => import("@/views/admin/banner/function"),
        default: true,
        meta: {
            model: "banner",
            // requiresAuth: true,
        },
    },
    {
        path: "list-banner/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/banner/function"),
        default: true,
        meta: {
            model: "banner",
            // requiresAuth: true,
        },
    },
];
export default bannerRouter;